"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowActionsRendererFactory = void 0;
const WorkflowActionType_1 = require("@opsbase/lib-workflow/WorkflowAction/WorkflowActionType");
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const Tooltip_1 = __importDefault(require("@opsbase/web-ui/Tooltip"));
const WorkflowActionLabel_1 = __importDefault(require("@opsbase/web-workflow/WorkflowActionLabel"));
const react_1 = __importDefault(require("react"));
const WorkflowActionsRendererFactory = (viewField) => (workflow) => {
    const values = workflow[viewField.propertyName];
    if (!values)
        return null;
    if (values.length === 0) {
        return react_1.default.createElement(Text_1.default, null, '');
    }
    if (values.length === 1) {
        return react_1.default.createElement(WorkflowActionLabel_1.default, { action: values[0] });
    }
    else if (values.length > 1) {
        return (react_1.default.createElement(Tooltip_1.default, { tip: react_1.default.createElement(Vertical_1.default, null, values.map(v => (react_1.default.createElement(WorkflowActionLabel_1.default, { action: v })))) },
            react_1.default.createElement(Text_1.default, null, (0, WorkflowActionType_1.workflowActionTypeLabel)(values[0]['workflowActionType']) +
                ' +' +
                (values.length - 1))));
    }
    return null;
};
exports.WorkflowActionsRendererFactory = WorkflowActionsRendererFactory;
exports.default = exports.WorkflowActionsRendererFactory;
